module.exports = __webpack_public_path__ + "04_mid_yellow.e0666bd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/04_mid_yellow.png
// module id = ypBU
// module chunks = 0